import {Routes} from "@angular/router";
import {BusinessCasesComponent} from "./business-cases/business-cases.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";

export enum InventoryRoutes {
  BusinessCases = 'businesscases'
}

export const INVENTORY_ROUTES: Routes = [
  {
    path: InventoryRoutes.BusinessCases,
    component: BusinessCasesComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.Permissions_Inventory_BusinessCasesComponent().default},
    title: "Geschäftsvorfälle"
  }
]
